import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeotabService } from 'src/app/services/geotab.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-bus-details',
  templateUrl: './bus-details.component.html',
  styleUrls: ['./bus-details.component.scss']
})
export class BusDetailsComponent implements OnInit {

  busDetails: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private modalService: ModalService,
    private geotabService: GeotabService
  ) { 
    
  }

  ngOnInit(): void {
    console.log(this.data)
    this.geotabService.getBusDetails(this.data?.details?.id).subscribe((res) => {
      if(res){
        console.log({res});
        this.busDetails = res?.details;
      }
    })
  }

  get passengerPWD() {
    return this.busDetails?.activePassengers
      ? this.busDetails.activePassengers?.filter(e => e?.userPWD === 'yes')?.reduce((sum, e) => sum + (e?.quantity || 0), 0) : 0;
  }

  get passengerSenior() {
    return this.busDetails?.activePassengers
      ? this.busDetails.activePassengers?.filter(e => e?.userSenior === 'yes')?.reduce((sum, e) => sum + (e?.quantity || 0), 0) : 0;
  }

  get passengerStudent() {
    return this.busDetails?.activePassengers
      ? this.busDetails.activePassengers?.filter(e => e?.userStudent === 'yes')?.reduce((sum, e) => sum + (e?.quantity || 0), 0) : 0;
  }

  get passengerRegular() {
    return this.busDetails?.activePassengers
      ? this.busDetails.activePassengers?.filter(e => e?.userPWD === 'no' && e?.userSenior === 'no' && e?.userStudent === 'no')?.reduce((sum, e) => sum + (e?.quantity || 0), 0)
      : 0;
  }

  get getTotalPassengers(){
    return this.busDetails?.activePassengers?.reduce((sum, item) => sum + (item.quantity || 0), 0);
  }

  close(){
    this.modalService.hideBusDetails();
  }

  moreDetails(){
    this.modalService.showBusMoreDetails(this.busDetails);
  }
}
